import React, { useId } from "react";
import { Link } from "react-router-dom";

export default function DynamicExpertiseSection({ data }) {
  const titleId = useId();
  if (!data) return null;

  return (
    <section className="dynamic-expertise-section" aria-labelledby={titleId}>
      <div className="container">
        <div className="row align-items-center dynamic-expertise-row">
          <div className="col-lg-6">
            <img className="dynamic-expertise-image" src={data.image} alt={data.imageAlt} width="780" height="702" loading="lazy" />
          </div>
          <div className="col-lg-6">
            <div className="dynamic-expertise-content">
              <span className="main-title">{data.eyebrow}</span>
              <h2 className="heading" id={titleId}>{data.title}</h2>
              <p>{data.description}</p>
              <Link className="default-btn" to={data.buttonLink}>{data.buttonText}</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
